import jquery from 'jquery';
import EventBus from '@/event-bus';
import Cart from '@/cart';

import _round from 'lodash/round';
import _toFinite from 'lodash/toFinite';
import _toString from 'lodash/toString';
import _isUndefined from 'lodash/isUndefined';

import Shop from '@/shop';
import _Singleton from '@/tools/singleton';

import options from '@/ui/ui_add-cart-counter/default-selectors.json';
import defaultSettings from '@/ui/ui_add-cart-counter/default-settings.json';
import haveSameKeys from '@/helpers/haveSameKeys';
import getProductAccessoriesData from '@/helpers/getProductAccessoriesData';
import getProductFullAccessoriesData from '@/helpers/getProductFullAccessoriesData';

/**
 * @class
 * @private
 *
 * @description
 * DOM + AddCartCounter
 */
const AddCartCounterDOM = function() {
  const self = this;
  this.cartItems = [];
  this.forbidOrderOverExisting = Shop.config.config.forbid_order_over_existing;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._init = function() {
  const self = this;
  self.options = options;
  self.defaultSettings = defaultSettings;

  self._bindMinusBtn();
  self._bindPlusBtn();

  EventBus.subscribe('update_items:insales:cart:light', function(eventData) {
    self.cartItems = eventData.order_lines;
  });

  EventBus.subscribe('update_items:insales:cart', function(eventData) {
    if (eventData.action.button && !_isUndefined(jquery(eventData.action.button[0]).attr(self.options.counter.value))) {
      return false;
    }

    if (eventData.action.currentItems && !eventData.action.currentItems.length) {
      self._resetCountItem();
    }

    if (eventData.action.currentItems) {
      jquery.each(eventData.action.currentItems, function(index, value) {
        self._updateForCartLineItem(value);
      });
    }
  });

  EventBus.subscribe('update_variant:insales:product', function(eventData) {
    if (eventData.action && eventData.action.product) {
      self._updateForSwitchVariant(eventData);
    }
  });

  EventBus.subscribe('prices-calculated:insales:ui_accessories', function(eventData) {
    self._updateForSwitchAccessories(eventData);
  });
};

/**
 * @private
 *
 * @description
 * Обработчик уменьшения количества (удаления товара из корзины)
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._bindMinusBtn = function() {
  const self = this;

  jquery(document).on('click', self.options.counterMinus.attr, function() {
    self._updateForActionPlusMinus('minus', jquery(this));
  });
};

/**
 * @private
 *
 * @description
 * Обработчик увеличения количества (добавления товара в корзину)
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._bindPlusBtn = function() {
  const self = this;

  jquery(document).on('click', self.options.counterPlus.attr, function() {
    self._updateForActionPlusMinus('plus', jquery(this));
  });

  jquery(document).on('click', self.options.counterBtn.attr, function() {
    self._updateForActionPlusMinus('plus', jquery(this));
  });
};

/**
 * @private
 *
 * @description
 * Обновление состояния при смене модификации товара
 * @param {Object} eventData - объект с данными о смене модификации
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._updateForSwitchVariant = function(eventData) {
  const self = this;

  const productNode = jquery(eventData.action.product[0]);
  const counterNode = productNode.find(self.options.counter.attr);
  const counterCountNode = productNode.find(self.options.counterCount.attr);

  const maxQuantity = eventData.quantity === null ? 'null' : eventData.quantity;
  counterNode.attr(self.options.counterMaxQuantity.value, maxQuantity);

  const variantInCart = window.InsalesCommonCart.order.getItemByID(eventData.id, true);
  const accessoriesData = getProductAccessoriesData(productNode.get(0));

  if (variantInCart.length) {
    // Ищем тот вариант товара у которого набор опций совпадает с выбранными опциями в карточке товара
    const matchedItem = variantInCart.find(item => haveSameKeys(item.accessory_value_ids, accessoriesData));
    // Если находим, то выводим его количество
    if (matchedItem) {
      counterNode.addClass(self.defaultSettings.classes.isAddCart);
      counterCountNode.text(matchedItem.quantity);
    // Если в карточке товара не выбрана ни одна опция, и в корзине есть этот вариант без опций, то выводим его количество
    } else if (!Object.keys(accessoriesData).length) {
      const itemWithoutAccessories = variantInCart.find(item => !item.accessory_value_ids);

      if (!itemWithoutAccessories) {
        counterNode.attr(self.options.counterIsReady.value, '');

        return;
      }

      counterNode.addClass(self.defaultSettings.classes.isAddCart);
      counterCountNode.text(itemWithoutAccessories.quantity);
    }
  } else {
    counterNode.removeClass(self.defaultSettings.classes.isAddCart);
    counterCountNode.text(0);
  }

  counterNode.attr(self.options.counterIsReady.value, '');
};

/**
 * @private
 * @description
 * Обновление состояния при смене аксессуаров
 * @param {Object} eventData - объект с данными об изменении опций
 * @return {void}
 */
AddCartCounterDOM.prototype._updateForSwitchAccessories = function(eventData) {
  const self = this;

  if (!eventData.productNode || eventData.isForCartUpdate) {
    return;
  }

  const curVariantIdField = eventData.productNode.querySelector('[name="variant_id"]');
  const currentVariantId = curVariantIdField ? parseInt(curVariantIdField.value) : 0;
  const accessoriesData = getProductAccessoriesData(eventData.productNode);

  const counterNode = eventData.productNode.querySelector(self.options.counter.attr);
  const counterCountNode = eventData.productNode.querySelector(self.options.counterCount.attr);

  // Это странно, но иногда мы можем обратиться к корзине когда она ещё не заинитилась, воспроизвёл только локально
  if (!counterNode || !counterCountNode
    || !window.InsalesCommonCart.order.order_lines
    || !window.InsalesCommonCart.order.order_lines.length) { return; }

  const match = window.InsalesCommonCart.order.order_lines.find(orderLine => {
    if (currentVariantId !== orderLine.variant_id) { return false; }

    if (
      (!orderLine.accessory_value_ids && !Object.keys(accessoriesData).length)
      || (orderLine.accessory_value_ids && haveSameKeys(orderLine.accessory_value_ids, accessoriesData))
    ) {
      return true;
    }
  });

  if (match) {
    counterNode.classList.add(self.defaultSettings.classes.isAddCart);
    counterCountNode.textContent = match.quantity;
  } else {
    counterNode.classList.remove(self.defaultSettings.classes.isAddCart);
    counterCountNode.textContent = 0;
  }
};

/**
 * @private
 *
 * @description
 * Обновление состояния при изменении количества
 *
 * @param {string} actionType - тип действия (plus, minus)
 * @param {Object} btnNode - кнопка, на которую нажали
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._updateForActionPlusMinus = function(actionType, btnNode) {
  const self = this;

  const product_node = btnNode.parents('[data-product-id]:first');
  const counter_btn = product_node.find(self.options.counter.attr);

  if (typeof counter_btn.attr(self.options.counterIsReady.value) === 'undefined') {
    return;
  }

  const comment_node = product_node.find('[name="comment"]');
  const product_id = product_node.data('productId');
  const variant_id = parseInt(product_node.find('[name="variant_id"]:first').val());
  const action_items = {};
  const action_comments = {};

  const accessoriesData = getProductAccessoriesData(product_node.get(0));

  const variant_max_quantity = product_node.find(self.options.counter.attr).attr(self.options.counterMaxQuantity.value);
  const variant_max_quantity_value = _round(_toFinite(variant_max_quantity), 3);

  let counter_count_elem_value = 0;
  if (product_node.find(self.options.counterCount.attr)[0]) {
    counter_count_elem_value = product_node.find(self.options.counterCount.attr)[0].textContent;
  }

  const prev_count = _round(_toFinite(counter_count_elem_value), 3);

  const step_settings = btnNode.parents(self.options.counter.attr).data(self.options.counter.data);
  let step = self.defaultSettings.step;
  let min = self.defaultSettings.min;

  if (step_settings && step_settings.step) {
    step = _round(_toFinite(step_settings.step), 3);
  }

  if (step_settings && step_settings.min) {
    min = _round(_toFinite(step_settings.min), 3);
  }

  if (Object.keys(accessoriesData).length) {
    action_items.accessoriable_variant_ids = {};
    action_items.accessoriable_variant_ids[variant_id] = [{
      quantity: step,
      accessory_value_ids: accessoriesData
    }];
  } else {
    action_items[variant_id] = step;
  }

  action_comments[variant_id] = comment_node.val();

  if (actionType === 'plus') {
    let added_count = 0;
    if (prev_count === 0) {
      const count_num = (min && min > step) ? min : step;

      if (Object.keys(accessoriesData).length) {
        action_items.accessoriable_variant_ids[variant_id] = [{
          quantity: _round(_toFinite(count_num), 3),
          accessory_value_ids: accessoriesData
        }];
      } else {
        action_items[variant_id] = _round(_toFinite(count_num), 3);
      }

      added_count = _round(_toFinite(prev_count + count_num), 3);
    } else {
      added_count = _round(_toFinite(prev_count + step), 3);
    }

    if (self.forbidOrderOverExisting && variant_max_quantity != 'null' &&
      (added_count > variant_max_quantity_value)
    ) {
      if (added_count - variant_max_quantity_value < step) {
        if (Object.keys(accessoriesData).length) {
          action_items.accessoriable_variant_ids[variant_id] = [{
            quantity: variant_max_quantity_value - (added_count - step),
            accessory_value_ids: accessoriesData
          }];
        } else {
          action_items[variant_id] = variant_max_quantity_value - (added_count - step);
        }

        Cart.add({
          items: action_items,
          comments: action_comments,
          button: btnNode.parents(self.options.counter.attr)
        });
      } else {
        const event_data = { button: btnNode };
        EventBus.publish('unchange_quantity:insales:ui_add-cart-counter', event_data);

        return false;
      }
    } else {
      Cart.add({
        items: action_items,
        comments: action_comments,
        button: btnNode.parents(self.options.counter.attr)
      });
    }
  }

  if (actionType === 'minus') {
    if (prev_count === min) {
      if (Object.keys(accessoriesData).length) {
        action_items.accessoriable_variant_ids[variant_id] = [{
          quantity: min,
          accessory_value_ids: accessoriesData
        }];
      } else {
        action_items[variant_id] = min;
      }
    }

    Cart.remove({
      items: action_items,
      button: btnNode.parents(self.options.counter.attr)
    });
  }

  // Обновляем кнопки во всех блоках для данного товара
  jquery(`[data-product-id=${product_id}]`).each(function() {
    const current_product_node = jquery(this);
    const current_active_variant_id = parseInt(current_product_node.find('[name="variant_id"]:first').val());

    const currentProductAccessoryItems = current_product_node.find('[data-product-accessory-values-item]');
    // Получаем выбранные опции из карточки
    const currentAccessoriesData = getProductAccessoriesData(current_product_node.get(0));

    if (current_active_variant_id !== variant_id) { return; }

    if (currentProductAccessoryItems.length && !haveSameKeys(currentAccessoriesData, accessoriesData)) { return; }

    const productFullAccessoryData = getProductFullAccessoriesData(current_product_node.get(0));

    // Если у товара есть опции и количество выбранных значений не совпадает с минимальным, или больше максимального, то ничего не делаем
    if (Object.keys(productFullAccessoryData).length && window.Products._products[product_id]) {
      let accessoriesCountError = false;

      Object.values(window.Products._products[product_id].product.accessories).forEach(accessoryData => {
        if (!accessoryData.min_count) { return; }

        if (
          productFullAccessoryData[accessoryData.id]
          && (
            Object.keys(productFullAccessoryData[accessoryData.id]).length < accessoryData.min_count
            || Object.keys(productFullAccessoryData[accessoryData.id]).length > accessoryData.max_count
          )
        ) {
          accessoriesCountError = true;
        }
      });

      if (accessoriesCountError) { return; }
    }

    const count_node = current_product_node.find(self.options.counterCount.attr);

    if (actionType === 'plus') {
      let result_count_num = step;

      if (prev_count === 0) {
        result_count_num = (min && min > step) ? min : step;
      }

      let show_count = _round(_toFinite(prev_count + result_count_num), 3);

      if (
        self.forbidOrderOverExisting && variant_max_quantity != 'null'
        && (show_count > variant_max_quantity_value)
      ) {
        if (show_count - variant_max_quantity_value < step) {
          show_count = variant_max_quantity_value;
        }
      }
      count_node.text(show_count);

      current_product_node.find(self.options.counter.attr).addClass(self.defaultSettings.classes.isAddCart);
    }

    if (actionType === 'minus') {
      if (prev_count <= step || prev_count <= min) {
        count_node.text(0);
        jquery(current_product_node)
          .find(self.options.counter.attr)
          .removeClass(self.defaultSettings.classes.isAddCart);

        return;
      }

      count_node.text(_toString(_round(_toFinite(prev_count - step), 3)));
    }
  });
};

/**
 * @private
 *
 * @description
 * Обновление состояния при изменении корзины
 * @param {Object} cartLine - объект с данными о товаре в корзине
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._updateForCartLineItem = function(cartLine) {
  const self = this;

  const product_id = cartLine.product_id;
  const variant_id = cartLine.id;
  const quantity = _round(_toFinite(cartLine.quantity), 3);

  // Обновляем кнопки во всех блоках для данного товара
  jquery(`[data-product-id=${product_id}]`).each(function() {
    const product_node = jquery(this);
    const current_active_variant_id = parseInt(product_node.find('[name="variant_id"]:first').val());

    const btn_counter_node = product_node.find(self.options.counter.attr);
    const count_node = btn_counter_node.find(self.options.counterCount.attr);

    const variant_in_cart = window.InsalesCommonCart.order.getItemByID(variant_id, true);
    // Получаем выбранные опции из карточки
    const accessoriesData = getProductAccessoriesData(product_node.get(0));

    if (current_active_variant_id === variant_id) {
      if (quantity <= 0 || !variant_in_cart) {
        count_node.text(0);
        btn_counter_node.removeClass(self.defaultSettings.classes.isAddCart);
      } else {
        if (Array.isArray(variant_in_cart)) {
          const matchedItem = variant_in_cart.find(item => haveSameKeys(item.accessory_value_ids, accessoriesData));
          if (matchedItem) {
            btn_counter_node.addClass(self.defaultSettings.classes.isAddCart);
            count_node.text(matchedItem.quantity);
          } else if (!Object.keys(accessoriesData).length && variant_in_cart[0]) {
            btn_counter_node.addClass(self.defaultSettings.classes.isAddCart);
            count_node.text(variant_in_cart[0].quantity);
          }
        }

        count_node.text(quantity);
        btn_counter_node.addClass(self.defaultSettings.classes.isAddCart);
      }
    }
  });
};

/**
 * @private
 *
 * @description
 * Обнуляем все кнопки
 *
 * @return {void}
 */
AddCartCounterDOM.prototype._resetCountItem = function() {
  const self = this;

  // Обнуляем кнопки во всех блоках для данного товара
  jquery('[data-product-id]').each(function() {
    const product_node = jquery(this);

    const btn_counter_node = product_node.find(self.options.counter.attr);
    const count_node = btn_counter_node.find(self.options.counterCount.attr);

    count_node.text(0);
    jquery(product_node).find(self.options.counter.attr).removeClass(self.defaultSettings.classes.isAddCart);
  });
};

export default _Singleton(AddCartCounterDOM).getInstance();
